// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-block svg {
    fill: #000;
  }
  .login-block:hover svg {
    fill: #fff;
  }
  .login-block:hover svg path {
    fill: #fff;
  }`, "",{"version":3,"sources":["webpack://./src/pages/login-help/style.css"],"names":[],"mappings":"AAAA;IACI,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ","sourcesContent":[".login-block svg {\n    fill: #000;\n  }\n  .login-block:hover svg {\n    fill: #fff;\n  }\n  .login-block:hover svg path {\n    fill: #fff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
